import _ from 'lodash';
import React from 'react';

/**
 * @description Renders a read-only list of elements.
 * Handles validation for null, undefined, non-array, or empty data by displaying a fallback '---'.
 * Individual null or empty values within the array also render the fallback indicator.
 * @param {any[]} fieldValues - Array of values to be rendered as list items.
 * @example
 * // Renders a list of items
 * ListModeView({['Value 1', 'Value 2']})
 * // Renders: <span class="read-only-empty-field">---</span>
 * ListModeView({[]})
 */
export const ListModeView = (fieldValues: any) => {
  if (
    _.isNil(fieldValues) ||
    !_.isArray(fieldValues) ||
    _.isEmpty(fieldValues)
  ) {
    return (
      <div className={'read-only-text'}>
        <span className={'read-only-empty-field'}>---</span>
      </div>
    );
  }
  return (
    <div className={'read-only-list'}>
      {fieldValues.map((value: any, index) => {
        const hasValue = !_.isNil(value) && value !== '';
        return (
          <div key={`${value}-${index}`} className={'read-only-list-item'}>
            {hasValue ? (
              <span className={'read-only-list-item-text'}>{value}</span>
            ) : (
              <span className={'read-only-empty-field'}>---</span>
            )}
          </div>
        );
      })}
    </div>
  );
};
